import { render } from "./Clay.vue?vue&type=template&id=f38cbb1a"
import script from "./Clay.vue?vue&type=script&lang=js"
export * from "./Clay.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/productionOverview/Clay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f38cbb1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f38cbb1a', __exports__)) {
    api.reload('f38cbb1a', __exports__)
  }
  
  module.hot.accept("./Clay.vue?vue&type=template&id=f38cbb1a", () => {
    api.rerender('f38cbb1a', render)
  })

}


export default __exports__